import { useEffect, useRef, useState } from "react";

export function StatCounter({
  value,
  label,
  suffix = "",
  dark = false,
}: {
  value: number;
  label: string;
  suffix?: string;
  dark?: boolean;
}) {
  const [n, setN] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const duration = 1400;
          const start = performance.now();
          const step = (now: number) => {
            const p = Math.min((now - start) / duration, 1);
            setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
          obs.disconnect();
        }
      },
      { threshold: 0.4 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [value]);

  return (
    <div ref={ref} className="text-center">
      <div className="font-display text-4xl md:text-5xl font-bold text-gradient">
        {n}
        {suffix}
      </div>
      <div
        className={`mt-2 text-sm font-medium ${dark ? "text-ink-muted" : "text-muted-foreground"}`}
      >
        {label}
      </div>
    </div>
  );
}
